<template>
    <basic-modal @hide="close"
                 v-model="opened"
                 :aria-label="popupConfig.header"

                 role="dialog">
        <div slot="header">
            <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
            <h3 class="modal-title">{{ popupConfig.header }}</h3>
        </div>
        <div>
            <div class="row">
                <div class="col-sm-12">
                    Section name:
                    <input
                            type="text"
                            ref="sectionName"
                            v-model="sectionData.caption"
                            placeholder="Give this section a name"
                            class="form-control"
                            :disabled="!popupConfig.allow_change_name"
                            minlength="2" maxlength="55"/>
                    <br v-if="popupConfig.additional_info">
                    <i>{{ popupConfig.additional_info }}</i>
                    <hr>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4" v-if="!sectionData.avatar">
                    <btn class="btn btn-mm text-left"
                         style="width: 173px; padding: 7px 15px 13px 0;"
                         @click="addAvatar">
                    <span class="vertical-middle"
                          style="text-align: center;
                        display: inline-block;"> <i class="fa fa-image fa-2"></i>
                    </span>
                        <span class="vertical-middle"> + Add Picture</span>
                    </btn>
                </div>
                <div class="col-sm-8" v-if="!sectionData.avatar">
                    Multi Me will automatically select a picture if you do not add one here.
                </div>
                <div class="col-sm-4" v-if="sectionData.avatar">
                    <media-preview :item="sectionData.avatar" allow-delete @onDelete="resetAvatar"></media-preview>
                </div>
                <div class="col-sm-4" v-if="sectionData.avatar">
                    Avatar: {{ sectionData.avatar.name }}
                </div>
            </div>

            <div class="row margin-15-top" v-if="!sectionData.audio_caption">
                <div class="col-sm-4">
                    <btn class="btn btn-mm text-left"
                         style="width: 173px;text-align: left; padding: 7px 15px 13px 0;"
                         @click="addAudio">
                        <span class="vertical-middle" style="    width: 37px; margin-left: 4px;
                                text-align: center;
                                display: inline-block;">
                            <i class="fa fa-microphone fa-2 vertical-middle"></i>
                        </span>
                        <span class="vertical-middle"> + Add Audio</span>
                    </btn>
                </div>
                <div class="col-sm-8" v-if="!sectionData.audio_caption">
                    Add an audio caption so users can listen to the name.
                </div>
            </div>
            <div class="row margin-15-top" v-else>
                <div class="col-sm-4">
                    <media-preview :item="sectionData.audio_caption" allow-delete
                                   @onDelete="resetAudio"></media-preview>
                </div>
                <div class="col-sm-8">
                    Audio caption: {{ sectionData.audio_caption.name }}
                </div>
            </div>
            <div class="row margin-15-top" v-if="popupConfig.allow_create_subsections">
                <div class="col-sm-4">
                    <vue-switch-with-label v-model="sectionData.is_submenu" label="" name="ms"></vue-switch-with-label>
                </div>
                <div class="col-sm-8">
                    Create multiple sections inside this section
                </div>
            </div>
        </div>
        <div slot="footer" class="row">
            <div class="col-xs-4 text-left">
                <button class="btn btn-mm btn-red" @click="del" v-if="popupConfig.allow_delete">Delete</button>
            </div>
            <div class="col-xs-8 text-right">
                <button class="btn btn-mm btn-green" :disabled="!sectionData.caption" @click="create">
                    {{ popupConfig.save_button }}
                </button>
            </div>
        </div>
    </basic-modal>
</template>

<script lang="js">
    import Vue, { defineComponent } from 'vue';
    import PopupPromiseMixin from '~/vue/mixins/PopupPromiseMixin.js';

    const defaultSectionData = {
        caption: '',
        avatar: undefined,
        is_submenu: false,
        audio_caption: undefined,
    };

    const defaultPopupConfig = {
        header: 'Create New Wiki Section',
        save_button: 'Create',
        cancel_button: 'Cancel',
        allow_create_subsections: false,
        create_subsection_switch_disabled: false,
        additional_info: undefined,
        allow_delete: false,
        allow_change_name: true,
    };

    export default defineComponent({
        components: {},
        mixins: [PopupPromiseMixin],
        name: 'CreateEditSectionPopup',
        data() {
            return {
                popupConfig: Object.assign({}, defaultPopupConfig),
                sectionData: Object.assign({}, defaultSectionData),
            };
        },
        computed: {
            firstFocusEl() {
                return this.$refs.sectionName;
            },
        },
        methods: {
            setInitial(popupConfig, sectionData) {
                this.popupConfig = Object.assign({}, defaultPopupConfig, popupConfig);
                this.sectionData = (({
                    caption,
                    avatar,
                    is_submenu,
                    audio_caption
                }) => ({
                    caption,
                    avatar,
                    is_submenu,
                    audio_caption
                }))(Object.assign({}, defaultSectionData, sectionData));
            },
            async addAvatar() {
                this.tmpHide();
                // @ts-ignore
                const addMedia = Vue.getAngularModule('addMedia');
                addMedia.add_media(
                    {
                        allow_add_from_library: true,
                        max_count: 1,
                        type: 'image',
                        popup_header: 'Select Image'
                    },
                    {
                        default_callback: (items_list) => {
                            this.sectionData.avatar = items_list[0];
                            this.tmpShow();
                        },
                        cancel_callback: () => {
                            this.tmpShow();
                        }
                    }
                );

            },
            async addAudio() {
                this.tmpHide();
                const addMedia = Vue.getAngularModule('addMedia');
                addMedia.add_media(
                    {
                        allow_add_from_library: true,
                        max_count: 1,
                        type: 'audio',
                        popup_header: 'Select Audio'
                    },
                    {
                        default_callback: (items_list) => {
                            this.sectionData.audio_caption = items_list[0];
                            this.tmpShow();
                        },
                        cancel_callback: () => {
                            this.tmpShow();
                        }
                    }
                );

            },
            resetAvatar() {
                this.sectionData.avatar = undefined;
            },
            resetAudio() {
                this.sectionData.audio_caption = undefined;
            },
            del() {
                this.save({ type: 'delete' });
            },
            create() {
                this.save({
                    data: this.sectionData,
                    type: 'save'
                });
            },
        }
    });


</script>

<style scoped lang="scss">

</style>
